import React from 'react'
import { dateToLocal } from '@/util/timeHelpers'
import DetailHeader from '@/components/ActivityDetail/DetailHeader'
import { ActionDetailProps } from '..'
import { Separator } from '@/components'
import { ConvertedItems } from './converted'
import { ArcadeConvertedItems } from '@/api/resources/shared/action'

const Arcade = ({ id, activity }: ActionDetailProps) => {
  const { time_created, info_count } = activity
  const details = [
    { label: 'Date', value: dateToLocal({ date: time_created }) },
    { label: 'Transaction ID', value: `#${id}` },
    { label: 'Number of Items', value: info_count }
  ]

  const convertedItems = activity.data as ArcadeConvertedItems

  return (
    <>
      <DetailHeader details={details} />
      <Separator className="my-3" />
      <ConvertedItems items={convertedItems} />
    </>
  )
}

export default Arcade
